;(function ($) {
    'use strict';

    const pluginName = 'articleBuy';

    /**
     * Article-Buy Plugin
     *
     * @deprecated Use ArticleBuy (typescript) instead
     * @param elements
     * @return {Plugin}
     * @constructor
     */
    function Plugin(elements) {
        this._name = pluginName;
        this.elements = $(elements);
        this.combinedIdToElementsIdx = new Map();
        this.elementIdToElementIdx = new Map();
		this.updateRequest = null;

        this.init();
        return this;
    }

    function guidGenerator() {
        const S4 = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    }

    $.extend(Plugin.prototype, {
        init: function () {
            const that = this;
            const request = {
                items: {}
            }

            if (this.elements.length === 0) {
                return;
            }

            $(window).on('buy-data-quantity-change', function (event) {
                that.update(event.itemId, event.quantity, event.updateElements, event.callback);
            });

            this.elements.each(function (i) {
                // make sure element hasn't been processed yet
                if ($(this).data(pluginName)) {
                    return;
                }

                const guid = guidGenerator();
                $(this).data(pluginName, guid);
                that.elementIdToElementIdx.set(guid, i);

                // get id from element
                let id = $(this).data('item-id');
                if (id === undefined) {
                    return;
                }

                id = id.toString();
                if (id === '') {
                    return;
                }

                // get quantity from element
                let quantity = $(this).data('item-quantity');
                if (quantity === '' || quantity === undefined) {
                    quantity = 1;
                }

                // init request for id
                if (!request.items.hasOwnProperty(id)) {
                    request.items[id] = {
                        itemId: id,
                        quantities: [],
                        store: false
                    };
                }

                // map combination of id and quantity to element index
                const combinedId = id + '-' + quantity;
                if (!that.combinedIdToElementsIdx.has(combinedId)) {
                    that.combinedIdToElementsIdx.set(combinedId, []);
                }

                that.combinedIdToElementsIdx.get(combinedId).push(i);

                if (!request['items'][id]['store']) {
                    request['items'][id]['store'] = $(this).data('article-buy-store') ?? false;
                }

                // add quantity to request
                if (!request['items'][id]['quantities'].includes(quantity)) {
                    request['items'][id]['quantities'].push(quantity);
                }
            });

            if (Object.keys(request.items).length === 0) {
                return;
            }

            this.query(request);
        },
        update: function (itemId, quantity, elements, callback) {
            const that = this;
            this.updateRequest = $.ajax({
                url: '/api/v1/buy',
                method: 'POST',
                data: JSON.stringify({
                    items: {
                        [itemId]: {
                            itemId: itemId,
                            updateStored: true,
                            quantities: [quantity]
                        },
                    }
                }),
                success: function (response) {
                    const event = jQuery.Event("buy-data-loaded");
                    event.itemId = itemId;
                    event.article = response.items[itemId]
                    event.price = response.items[itemId]['prices'][quantity];

                    elements.forEach(function (id) {
                        const idx = that.elementIdToElementIdx.get(id);
                        $(that.elements[idx]).trigger(event);

                        if ($(that.elements[idx]).length > 0) {
                            const jsEvent = new CustomEvent('Plandent.Buy.DataLoaded', {
                                detail: {
                                    itemId: event.itemId,
                                    price: event.price,
                                    article: event.article
                                }
                            });
                            $(that.elements[idx])[0].dispatchEvent(jsEvent);
                        }
                    });

					if (callback !== undefined) {
						callback();
					}
                }
            });
        },
        query: function (request) {
            const that = this;

            $.ajax({
                url: '/api/v1/buy',
                method: 'POST',
                data: JSON.stringify(request),
                success: function (response) {
                    Object.keys(response.items).forEach(function (itemId) {
                        const event = jQuery.Event("buy-data-loaded");
                        event.itemId = itemId;
                        event.article = response.items[itemId];

                        if (!response.items[itemId].prices) {
                            console.warn('no prices for item "' + itemId + '"');
                        }

                        request['items'][itemId].quantities.forEach(function (quantity) {
                            const combinedId = itemId + '-' + quantity;

                            if (response.items[itemId]['prices']) {
                                event.price = response.items[itemId]['prices'][quantity];
                            }

                            if (that.combinedIdToElementsIdx.has(combinedId)) {
                                that.combinedIdToElementsIdx.get(combinedId).forEach(function (idx) {
                                    $(that.elements[idx]).trigger(event);

                                    if ($(that.elements[idx]).length > 0) {
                                        const jsEvent = new CustomEvent('Plandent.Buy.DataLoaded', {
                                            detail: {
                                                itemId: event.itemId,
                                                price: event.price,
                                                article: event.article
                                            }
                                        });
                                        $(that.elements[idx])[0].dispatchEvent(jsEvent);
                                    }
                                });
                            }
                        });
                    });

                    const event = jQuery.Event("buy-data-loaded-all");
                    $(window).trigger(event);

                    const jsEvent = new Event('Plandent.Buy.DataLoadedAll');
                    document.dispatchEvent(jsEvent);
                }
            });
        }
    });

    /**
     * Plugin Wrapper
     *
     * @param options
     * @returns {*}
     */
    $.fn[pluginName] = function (options) {
        if (options === undefined || typeof options === 'object') {
            return $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
        }
    };
})(jQuery);
